export const baseUrl =
  '/images/cases/platform-for-improving-diagnostic-accuracy'

export const config = {
  client: {
    title: 'Client',
    subtitle:
      'A well-established and trusted German cancer care clinic operating in the healthcare industry since 2010 contacted Modsen team with a view to finding expert engineers with a proven track record in implementing AI solutions for MedTech. The key activity of our partner consisted in the provision of personalized and prognostic data for cancer patient examination and diagnosis which could be significantly improved with the incorporation of advanced technologies.',
  },
  clientImage: {
    src: '/images/cases/client-ai-based-platform.webp',
    alt: 'AI-based platform interface',
    title: 'AI-based platform interface',
    width: 762,
    height: 572,
  },
  hexagonOrange: {
    width: 363,
    height: 363,
    src: `${baseUrl}/hexagonOrange.svg`,
    alt: '',
  },
}
